module.exports = __webpack_public_path__ + "static/TF-fa01c85c4c235575aa6f5bb396c90d4c.jpg";